import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionProceduresByInstitutionId: IInstitutionProceduresLoadByInstitutionIdActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURES_LOAD_BY_INSTITUTION_ID,
            institutionId
        }
    },
    LoadInstitutionProcedureById: IInstitutionProcedureLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IInstitutionProcedureLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionProcedureLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionProcedure: IInstitutionProcedureSaveActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_SAVE,
            formData
        }
    },
    SaveSuccess: IInstitutionProcedureSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionProcedureSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionProcedure: IInstitutionProcedureValidateActionCreator = (formData) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IInstitutionProcedureValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionProcedureValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionProcedure: IInstitutionProcedureCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONPROCEDURE_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionProcedureCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionProcedureCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncInstitutionProcedure: IInstitutionProcedureSyncActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONPROCEDURE_SYNC,
            institutionId
        }
    },
    SyncSuccess: IInstitutionProcedureSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: IInstitutionProcedureSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionProcedureClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_CLEAR,
            propertiesToClear
        }
    },

    Filter: IInstitutionProcedureFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONPROCEDURE_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONPROCEDURES_LOAD_BY_INSTITUTION_ID = "ACTION_INSTITUTIONPROCEDURES_LOAD_BY_INSTITUTION_ID",
    ACTION_INSTITUTIONPROCEDURE_LOAD_BY_ID = "ACTION_INSTITUTIONPROCEDURE_LOAD_BY_ID",
    ACTION_INSTITUTIONPROCEDURE_LOAD_SUCCESS = "ACTION_INSTITUTIONPROCEDURE_LOAD_SUCCESS",
    ACTION_INSTITUTIONPROCEDURE_LOAD_FAILURE = "ACTION_INSTITUTIONPROCEDURE_LOAD_FAILURE",

    ACTION_INSTITUTIONPROCEDURE_SAVE = "ACTION_INSTITUTIONPROCEDURE_SAVE",
    ACTION_INSTITUTIONPROCEDURE_SAVE_SUCCESS = "ACTION_INSTITUTIONPROCEDURE_SAVE_SUCCESS",
    ACTION_INSTITUTIONPROCEDURE_SAVE_FAILURE = "ACTION_INSTITUTIONPROCEDURE_SAVE_FAILURE",

    ACTION_INSTITUTIONPROCEDURE_VALIDATE = "ACTION_INSTITUTIONPROCEDURE_VALIDATE",
    ACTION_INSTITUTIONPROCEDURE_VALIDATE_SUCCESS = "ACTION_INSTITUTIONPROCEDURE_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONPROCEDURE_VALIDATE_FAILURE = "ACTION_INSTITUTIONPROCEDURE_VALIDATE_FAILURE",

    ACTION_INSTITUTIONPROCEDURE_CREATE = "ACTION_INSTITUTIONPROCEDURE_CREATE",
    ACTION_INSTITUTIONPROCEDURE_CREATE_SUCCESS = "ACTION_INSTITUTIONPROCEDURE_CREATE_SUCCESS",
    ACTION_INSTITUTIONPROCEDURE_CREATE_FAILURE = "ACTION_INSTITUTIONPROCEDURE_CREATE_FAILURE",

    ACTION_INSTITUTIONPROCEDURE_SYNC = "ACTION_INSTITUTIONPROCEDURE_SYNC",
    ACTION_INSTITUTIONPROCEDURE_SYNC_SUCCESS = "ACTION_INSTITUTIONPROCEDURE_SYNC_SUCCESS",
    ACTION_INSTITUTIONPROCEDURE_SYNC_FAILURE = "ACTION_INSTITUTIONPROCEDURE_SYNC_FAILURE",

    ACTION_INSTITUTIONPROCEDURE_CLEAR = "ACTION_INSTITUTIONPROCEDURE_CLEAR",

    ACTION_INSTITUTIONPROCEDURE_FILTER = "ACTION_INSTITUTIONPROCEDURE_FILTER";

export interface IInstitutionProceduresLoadByInstitutionIdAction {
    type: "ACTION_INSTITUTIONPROCEDURES_LOAD_BY_INSTITUTION_ID";
    institutionId: number;
}

export interface IInstitutionProceduresLoadByInstitutionIdActionCreator {
    (institutionId: number): IInstitutionProceduresLoadByInstitutionIdAction;
}

export interface IInstitutionProcedureLoadSuccessAction {
    type: "ACTION_INSTITUTIONPROCEDURE_LOAD_SUCCESS";
    formData: Dtos.InstitutionProcedure | Dtos.InstitutionProcedure[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionProcedureLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionProcedure | Dtos.InstitutionProcedure[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionProcedureLoadSuccessAction;
}

export interface IInstitutionProcedureLoadFailureAction {
    type: "ACTION_INSTITUTIONPROCEDURE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionProcedureLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionProcedureLoadFailureAction;
}

export interface IInstitutionProcedureLoadByIdAction {
    type: "ACTION_INSTITUTIONPROCEDURE_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionProcedureLoadByIdActionCreator {
    (id: number): IInstitutionProcedureLoadByIdAction;
}

export interface IInstitutionProcedureSaveAction {
    type: "ACTION_INSTITUTIONPROCEDURE_SAVE";
    formData: Dtos.InstitutionProcedure;

}

export interface IInstitutionProcedureSaveActionCreator {
    (
        formData: Dtos.InstitutionProcedure
    ): IInstitutionProcedureSaveAction;
}

export interface IInstitutionProcedureSaveSuccessAction {
    type: "ACTION_INSTITUTIONPROCEDURE_SAVE_SUCCESS";
    formData: Dtos.InstitutionProcedure;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionProcedureSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionProcedure,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionProcedureSaveSuccessAction;
}

export interface IInstitutionProcedureSaveFailureAction {
    type: "ACTION_INSTITUTIONPROCEDURE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionProcedureSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionProcedureSaveFailureAction;
}

export interface IInstitutionProcedureValidateAction {
    type: "ACTION_INSTITUTIONPROCEDURE_VALIDATE";
    formData: Dtos.InstitutionProcedure;

}

export interface IInstitutionProcedureValidateActionCreator {
    (
        formData: Dtos.InstitutionProcedure
    ): IInstitutionProcedureValidateAction;
}

export interface IInstitutionProcedureValidateSuccessAction {
    type: "ACTION_INSTITUTIONPROCEDURE_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionProcedure;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionProcedureValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionProcedure,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionProcedureValidateSuccessAction;
}

export interface IInstitutionProcedureValidateFailureAction {
    type: "ACTION_INSTITUTIONPROCEDURE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionProcedureValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionProcedureValidateFailureAction;
}

export interface IInstitutionProcedureCreateAction {
    type: "ACTION_INSTITUTIONPROCEDURE_CREATE",
    institutionId: number
}

export interface IInstitutionProcedureCreateActionCreator {
    (institutionId: number): IInstitutionProcedureCreateAction
}

export interface IInstitutionProcedureCreateSuccessAction {
    type: "ACTION_INSTITUTIONPROCEDURE_CREATE_SUCCESS";
    formData: Dtos.InstitutionProcedure;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IInstitutionProcedureCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionProcedure,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionProcedureCreateSuccessAction;
}

export interface IInstitutionProcedureCreateFailureAction {
    type: "ACTION_INSTITUTIONPROCEDURE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionProcedureCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionProcedureCreateFailureAction;
}

export interface IInstitutionProcedureClearAction {
    type: "ACTION_INSTITUTIONPROCEDURE_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionProcedureClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionProcedureClearAction;
}

export interface IInstitutionProcedureFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionProcedureFilterAction;
}

export interface IInstitutionProcedureFilterAction {
    type: "ACTION_INSTITUTIONPROCEDURE_FILTER";
    formFilter: IFormFilter;
}

export interface IInstitutionProcedureSyncAction {
    type: "ACTION_INSTITUTIONPROCEDURE_SYNC",
    institutionId: number
}

export interface IInstitutionProcedureSyncActionCreator {
    (institutionId: number): IInstitutionProcedureSyncAction
}

export interface IInstitutionProcedureSyncSuccessAction {
    type: "ACTION_INSTITUTIONPROCEDURE_SYNC_SUCCESS";
    formData: Dtos.InstitutionProcedure[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionProcedureSyncSuccessActionCreator {
    (
        formData: Dtos.InstitutionProcedure[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionProcedureSyncSuccessAction;
}

export interface IInstitutionProcedureSyncFailureAction {
    type: "ACTION_INSTITUTIONPROCEDURE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionProcedureSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionProcedureSyncFailureAction;
}

export type InstitutionProcedureAction =
    IInstitutionProceduresLoadByInstitutionIdAction |
    IInstitutionProcedureLoadByIdAction |
    IInstitutionProcedureLoadFailureAction |
    IInstitutionProcedureLoadSuccessAction |
    IInstitutionProcedureSaveAction |
    IInstitutionProcedureSaveSuccessAction |
    IInstitutionProcedureSaveFailureAction |
    IInstitutionProcedureValidateAction |
    IInstitutionProcedureValidateSuccessAction |
    IInstitutionProcedureValidateFailureAction |
    IInstitutionProcedureCreateAction |
    IInstitutionProcedureCreateSuccessAction |
    IInstitutionProcedureCreateFailureAction |
    IInstitutionProcedureSyncAction |
    IInstitutionProcedureSyncSuccessAction |
    IInstitutionProcedureSyncFailureAction |
    IInstitutionProcedureClearAction | 
    IInstitutionProcedureFilterAction;
